import React from "react";
import { Link } from "react-router-dom";

const tickerItems = [
  {
    label:
      "The Union Ministry of Home Affairs (MHA) has amended the Immigration and Foreigners Rules",
    to: "/articles/immigration-and-foreigners-rules",
    tag: "Immigiration",
  },
  {
    label: "BharatAbroad Weekly Newletter June 2026",
    to: "/newsletter/weekly-june-2026",
    tag: "Weekly Newsletter",
  },
  {
    label: "US Immigration Overhaul: What's Changing From August 2026",
    to: "/news/immigration-2026/us-visa-reforms",
    tag: "US Visa",
  },
  {
    label:
      "Cybercrime Alert: Scammers impersonating Indian Police target seniors abroad",
    to: "/cyber-crime-alert",
    tag: "Crime",
  },

  {
    label:
      "AI Goes Geopolitical: Export Controls, Government Stakes, and the Chip Squeeze Reshaping Tech in 2026",
    to: "/articles/ai-agents-mainstream-2026",
    tag: "Tech",
  },
  {
    label:
      "Energy in 2026: Hormuz Reopens, Nuclear Bets Double Down, and Summer Heat Strains the Grid",
    to: "/articles/energy-trend-in-2026",
    tag: "Energy",
  },
];

const tagColors = {
  Crime: { bg: "#fff0eb", color: "#c0440a", border: "#f5c9b3" },
  Tech: { bg: "#eaf3ff", color: "#1a5fb4", border: "#b6d4f7" },
  Energy: { bg: "#fffbe6", color: "#9a6c00", border: "#f5dfa0" },
};

function NewsBanner() {
  return (
    <>
      <style>{`
        .ba-card-wrap {
          border-top: 2px solid #C8720A;
          border-bottom: 1px solid #e8e8e8;
          background: #fff;
        }

        .ba-card-header {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 9px 16px 0;
        }

        .ba-card-heading {
          font-size: 0.6rem;
          font-weight: 700;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: #C8720A;
          font-family: 'Segoe UI', sans-serif;
          white-space: nowrap;
        }

        .ba-card-line {
          flex: 1;
          height: 1px;
          background: #f0e8df;
        }

        .ba-card-list {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
        }

        .ba-card-item {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          padding: 10px 16px 12px;
          border-right: 1px solid #f0f0f0;
          text-decoration: none;
          transition: background 0.15s;
        }

        .ba-card-item:last-child {
          border-right: none;
        }

        .ba-card-item:hover {
          background: #fff8f3;
          text-decoration: none;
        }

        .ba-card-num {
          font-size: 1.4rem;
          font-weight: 700;
          color: #f0e0d0;
          flex-shrink: 0;
          line-height: 1;
          margin-top: 2px;
          font-family: 'Segoe UI', sans-serif;
          user-select: none;
        }

        .ba-card-body {
          flex: 1;
          min-width: 0;
        }

        .ba-card-tag {
          display: inline-block;
          font-size: 0.58rem;
          font-weight: 700;
          padding: 2px 7px;
          border-radius: 4px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 4px;
          font-family: 'Segoe UI', sans-serif;
          border: 1px solid transparent;
        }

        .ba-card-text {
          font-size: 0.75rem;
          color: #222;
          line-height: 1.45;
          font-family: 'Segoe UI', sans-serif;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .ba-card-item:hover .ba-card-text {
          color: #C8720A;
        }

        /* ── Tablet: 2 columns ── */
        @media (max-width: 768px) {
          .ba-card-list {
            grid-template-columns: repeat(2, 1fr);
          }
          .ba-card-item:nth-child(2) {
            border-right: none;
          }
          .ba-card-item:nth-child(3) {
            grid-column: 1 / -1;
            border-right: none;
            border-top: 1px solid #f0f0f0;
          }
        }

        /* ── Mobile: 1 column ── */
        @media (max-width: 480px) {
          .ba-card-list {
            grid-template-columns: 1fr;
          }
          .ba-card-item {
            border-right: none;
            border-bottom: 1px solid #f5f5f5;
            padding: 9px 14px;
          }
          .ba-card-item:last-child {
            border-bottom: none;
          }
          .ba-card-item:nth-child(2) {
            border-right: none;
          }
          .ba-card-item:nth-child(3) {
            grid-column: auto;
            border-top: none;
          }
          .ba-card-num {
            font-size: 1.1rem;
          }
          .ba-card-text {
            font-size: 0.73rem;
          }
          .ba-card-header {
            padding: 8px 14px 0;
          }
        }
      `}</style>

      <div className="ba-card-wrap">
        <div className="ba-card-header">
          <span className="ba-card-heading">Latest</span>
          <div className="ba-card-line" />
        </div>

        <div className="ba-card-list">
          {tickerItems.map((item, i) => {
            const tc = tagColors[item.tag] || {
              bg: "#f5f5f5",
              color: "#555",
              border: "#ddd",
            };
            return (
              <Link key={i} to={item.to} className="ba-card-item">
                <div className="ba-card-num">0{i + 1}</div>
                <div className="ba-card-body">
                  <span
                    className="ba-card-tag"
                    style={{
                      background: tc.bg,
                      color: tc.color,
                      borderColor: tc.border,
                    }}
                  >
                    {item.tag}
                  </span>
                  <div className="ba-card-text">{item.label}</div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default NewsBanner;
